import SETTINGS from "../settings.json";
import { httpGet } from "./AbstractService";
import ENDPOINTS from "../data/endpoints.json";

export const getFullVersion = () => {
  return SETTINGS.fullVersion;
};

export const getAtpVersion = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].user}/atp/version`);
};
